import { View, Platform } from 'react-native';
import React, { ReactNode } from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

type Props = {
  children: ReactNode;
  bg?: string;
};

const ScreenWrapper: React.FC<Props> = ({ children, bg }) => {
  const { top } = useSafeAreaInsets();
  const paddingTop = top > 0 ? top + 5 : 30;

  // On native, we want a flex container that fills the screen.
  // On web, using flex: 1 on this wrapper can cause layout issues
  // (content appearing "blank" or pushed off-screen). Use minHeight instead.
  const containerStyle =
    Platform.OS === 'web'
      ? { minHeight: '100vh', paddingTop, backgroundColor: bg }
      : { flex: 1, paddingTop, backgroundColor: bg };

  return (
    <View style={containerStyle}>
      {children}
    </View>
  );
};

export default ScreenWrapper;
